<template class="main">
  <v-app id="app">
    <nav-bar class="my-2"/>
    <router-view :class="$vuetify.breakpoint.mobile ? 'mt-12' : ''"/>
    <Footer class="my-0"/>
  </v-app>
</template>

<script>
import Footer from './components/Footer.vue';
import NavBar from './components/NavBar.vue';

export default {
  components: { NavBar, Footer},  
};
</script>
<style>

  #app {
    height: 100%;
    font-size: 24px;
    width: 100%;
    font-family: Arial, Helvetica, sans-serif;
    color: #1b2f5a !important;
  }

  .v-btn {
    text-transform: capitalize;
  }

  .v-card {
    color: #1b2f5a !important;
  }

</style>
